import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { PopupHeaderComponent } from "../../common/popup-header/popup-header.component";

@Component({
    selector: "app-program-type-dialog",
    templateUrl: "./program-type-dialog.component.html",
    styleUrls: ["./program-type-dialog.component.scss"],
    imports: [PopupHeaderComponent]
})
export class ProgramTypeDialogComponent {
  constructor(public dialogRef: MatDialogRef<ProgramTypeDialogComponent>) {}

  selectType(type: "single" | "multi") {
    this.dialogRef.close(type);
  }
}
